import { pharmacyClient } from "@/connect";
import { PricingPendingAcceptanceResponse } from "@/gen/medical_master/pricing_pending_acceptance_pb";
import { Loading } from "@/layouts/loading";
import Component from "@/routes/company/_layout/inventory/pending-acceptance-inventory/-components/component";
import { createFileRoute } from "@tanstack/react-router";
import { SearchParams } from "./-data/model";

export const Route = createFileRoute("/company/_layout/inventory/pending-acceptance-inventory/")({
    component: Component,
    validateSearch: SearchParams,
    loaderDeps: ({ search: { page, pageSize } }) => ({ page, pageSize }),
    loader: async (params): Promise<PricingPendingAcceptanceResponse> => {
        return await pharmacyClient.pricingPendingAcceptance({
            page: params.deps.page,
            pageSize: params.deps.pageSize
        })
    },
    pendingComponent: () => <Loading />,
    pendingMinMs: 1000,
    pendingMs: 1
});